import CustomTable from "../../components/CustomTable/CustomTable";

const filters = [{ title: "Year", url: "year=" }];

const rowHeadings = [
    { title: "Invoice No.", key: "invoice_number" },
    { title: "Amount", key: "amount" },
    { title: "CGST", key: "cgst" },
    { title: "SGST", key: "sgst" },
    { title: "IGST", key: "igst" },
    { title: "Type", key: "type", capitalize: true },
    { title: "Date", key: "date" },

];

const GSTReport = () => {
    return (
        <div className="mx-4 mt-5 pt-5">
            <CustomTable
                rowHeadings={rowHeadings}
                filters={filters}
                backendUrl="invoice/gst-report"
                exportUrl="invoice/generate-gst-sheet/"
                exportMethod="POST"
                title="GST Report"
                subtitle={"All"}
                showSearchReset={true}
                showExport={true}
                download={true}     // Please select the year and month before downloading the report.
                exportUsesFilePath={true}

            />
        </div>
    );
};

export default GSTReport;
